// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckboxWithButton_wrapper__oNd-j","checkbox":"CheckboxWithButton_checkbox__sr43i","btn":"CheckboxWithButton_btn__HX67W"};